import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { getSalesReport } from "../network/api/reports.api";
import { SalesReportFilters } from "../network/api/types.api";

export const useSalesReport = (filters: SalesReportFilters) =>
  useQuery({
    queryKey: ["salesReport", filters],
    queryFn: () => getSalesReport(filters),
    placeholderData: keepPreviousData,
    meta: {
      errorMessage: "Failed to load sales report. Please try again.",
    },
  });
